/**
 * Lightbox for one inbound image attachment.
 *
 * Renders bytes the proxy already vetted (its Content-Type allowlist is raster images + PDF; PDFs
 * and everything else never reach this modal). The image arrives as an object URL created from an
 * in-memory Blob — candidate bytes never touch localStorage, and the URL is the CALLER's to
 * revoke (on close), because only the caller knows when the blob is done with.
 *
 * The filename is candidate-controlled text: rendered as text/alt, never markup.
 */
import { Paperclip } from 'lucide-react';
import { Modal, ModalContent } from '@finn-auto/design-system/atoms/modal';

export function AttachmentViewer({
  objectUrl,
  filename,
  onClose,
}: {
  objectUrl: string;
  filename: string;
  onClose: () => void;
}) {
  return (
    <Modal open onOpenChange={(next: boolean) => !next && onClose()}>
      <ModalContent
        className="!h-max !max-h-[calc(100dvh-2rem)] !w-[min(100vw-2rem,56rem)] gap-3 overflow-auto rounded p-4"
        data-no-toggle
      >
        <p className="truncate text-sm font-medium text-gray-700" title={filename}>
          <Paperclip className="mr-1 inline h-3.5 w-3.5" />
          {filename}
        </p>
        <img
          src={objectUrl}
          alt={filename}
          className="max-h-[75dvh] w-auto max-w-full self-center rounded object-contain"
        />
      </ModalContent>
    </Modal>
  );
}
